
// -- Gets the appropriate background color for the hacker's 
// support tickets list. 

const getStatusColor = (status: any) => {

    const green = ['active', 'accepted', 'paid']; 
    const brown = ['archived', 'inactive', 'pending']; 

    if (green.includes(status)) { 

        return 'rgba(73, 176, 55, 0.8)'; 

    } else if (status === 'test') { 

        return 'rgba(150, 21, 143, 0.8)'; 

    } else if (status === 'suspended') { 

        return 'rgba(179, 20, 14, 0.8)'; 

    } else if (status === 'blocked') { 
        
        return 'rgba(131, 47, 15, 0.8)'; 

    } else if (brown.includes(status)) { 

        return 'rgba(150, 75, 0, 0.8)'; 
        
    } else if (status === 'deleted') { 

        return 'rgb(135, 0, 0)'; 
        
    }  else if (status === 'admin') { 

        return 'rgb(26, 103, 240)'; 
        
    } else { 

        return 'transparent'; 
    };

};

export default getStatusColor; 